import styled from "styled-components";

export const ContainerNoti = styled.div`
  margin: 20px;
  .circle {
    width: 45px;
    height: 45px;
    background-color: var(--color-latex30);
    border-radius: 90%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .number-circle {
    position: absolute;
    top: -5px;
    right: -7px;
    width: 24px;
    height: 24px;
    background-color: var(--color-primary);
    border-radius: 90%;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    padding: 4px;
    color: #fff !important ;
  }
  @media screen and (max-width: 1365px) {
    display: none;
  }
  cursor: pointer;
`;

export const CircleMenu = styled.div``;

export const MenuContainerMobile = styled.div`
  /* width: 50px; */
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .number-circle {
    position: absolute;
    top: -6px;
    right: -14px;
    width: 28px;
    height: 28px;
    background-color: var(--color-primary);
    border-radius: 90%;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    padding: 4px;
  }
`;

export const HeaderBarMainContainer = styled.div`
  width: 100%;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 44px;
  background: var(--color-primary-gradient);
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14);

  @media (max-width: 1365px) {
    height: 52px;
    padding: 0 18px;
    transition: all 0.5s;
  }

  @media (max-width: 1365px) {
    ${({ $isIos }) =>
      $isIos === true
        ? `padding-top: 45px;
              height: 90px;
             `
        : `height: 52px;
      padding: 0 18px; `};
  }

  @media (max-width: 1024px) {
    width: 100%;
  }
`;
